import {
    CloseButton,
    Drawer,
    DrawerBody,
    DrawerContent,
    DrawerHeader,
    DrawerOverlay,
    useDisclosure
} from '@chakra-ui/react'
import { Logo, SystemVersion } from 'components/atoms'
import { Icon } from 'components/atoms/Icon'

import React from 'react'
import { Navigation } from '../Navigation'

export const NavigationDrawer: React.FC = () => {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const btnRef = React.useRef(null)

    return (
        <>
            <CloseButton
                ref={btnRef}
                onClick={onOpen}
                aria-label="close"
                marginLeft="auto"
                display="flex"
                data-testid="navigation-drawer-open"
            >
                <Icon
                    name="menu-burg"
                    data-testid="navigation-drawer-open-icon"
                />
            </CloseButton>
            <Drawer
                isOpen={isOpen}
                placement="left"
                onClose={onClose}
                finalFocusRef={btnRef}
                data-testid="navigation-drawer"
            >
                <DrawerOverlay data-testid="navigation-drawer-overlay" />
                <DrawerContent data-testid="navigation-drawer-content">
                    <DrawerHeader p={2} data-testid="navigation-drawer-header">
                        <CloseButton
                            onClick={onClose}
                            aria-label="close"
                            marginLeft="auto"
                            display="flex"
                            data-testid="navigation-drawer-close"
                        >
                            <Icon
                                name="close"
                                data-testid="navigation-drawer-close-icon"
                            />
                        </CloseButton>
                    </DrawerHeader>

                    <DrawerBody data-testid="navigation-drawer-body">
                        <Logo maxW={187} />
                        <Navigation redirect={onClose} />
                        <SystemVersion isOpen={isOpen} />
                    </DrawerBody>
                </DrawerContent>
            </Drawer>
        </>
    )
}
